import { Component, Input, OnInit } from '@angular/core';
import { Utility } from 'src/app/core/common';
import { JobtitleService } from 'src/app/services/jobtitle.service';
import { ResourceService } from 'src/app/services/resource.service';
import { SharedService } from 'src/app/services/shared.service';
import { SourceService } from 'src/app/services/source.service';
import { TopicService } from 'src/app/services/topic.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  Utility = Utility;
  toggle: any = {};
  rand: number;

  constructor(private jobtitleService: JobtitleService, private sourceService: SourceService, private topicService: TopicService) {
    this.rand = Math.random();
  }

  remoteJobtitles: any[] = [];
  bestDiscussions: any[] = [];
  resourceTypes = ResourceService.resourceTypes;
  sources: any[];

  async ngOnInit() {
    this.remoteJobtitles = await this.jobtitleService.remote();
    this.bestDiscussions = await this.topicService.hot();
    this.sources = await this.sourceService.sources$.toPromise();
  }

}
